export const SHELL_APP_PREFIX = 'goto'
